import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

interface MaintenanceState {
  shouldCheckMaintenance: boolean;
  isMaintenanceModeActive: boolean;
}

const initialState: MaintenanceState = {
  shouldCheckMaintenance: false,
  isMaintenanceModeActive: false,
};

const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    forceMaintenanceCheck: (state) => {
      state.shouldCheckMaintenance = true;
    },
    clearMaintenanceCheck: (state) => {
      state.shouldCheckMaintenance = false;
    },
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.isMaintenanceModeActive = action.payload;
    },
  },
});

export const { forceMaintenanceCheck, clearMaintenanceCheck, setMaintenanceMode } = maintenanceSlice.actions;

export const selectShouldCheckMaintenance = (state: RootState) =>
  state.maintenance.shouldCheckMaintenance;

export const selectIsMaintenanceModeActive = (state: RootState) =>
  state.maintenance.isMaintenanceModeActive;

export default maintenanceSlice.reducer;
